(() => {
  const node=document.getElementById('pb-personalization-config');
  if(!node||window.PBPersonalization)return;
  const config=JSON.parse(node.textContent), labels=config.labels;
  const state={mode:config.posterlyUrl?'posterly':'loading',configuredIds:null};
  let root,ui,form,observer,revision=0,appTimer,variantPending=false;
  let cartAttempt=null;
  const clearCartAttempt=()=>{cartAttempt=null;};
  // Customily finishes by clicking the original theme button. Permit that
  // handoff once, only after fresh generated properties reach this variant's form.
  const cartIdentityKeys=['_customily-personalization-id','_customily-production-url','_customily-preview','_customily-customization-url'];
  function completedCustomization(){
    const f=currentForm(),a=cartAttempt;
    return state.mode==='customily'&&isConfigured()&&a&&a.form===f&&
      a.variantId===String(variant()?.id)&&Date.now()-a.started<120000&&
      a.properties&&Object.entries(a.properties).every(([key,value])=>
        [...f.elements].some(input=>input.name===`properties[${key}]`&&input.value===value));
  }
  window.addEventListener('customily-starts-adding-to-cart',()=>{
    clearCartAttempt();
    if(state.mode==='customily'&&isConfigured())cartAttempt={form:currentForm(),variantId:String(variant().id),started:Date.now(),properties:null};
  });
  window.addEventListener('customily-properties-generated',event=>{
    if(!cartAttempt||cartAttempt.variantId!==String(variant()?.id))return;
    const properties=Object.fromEntries(cartIdentityKeys.filter(key=>typeof event.detail?.[key]==='string'&&event.detail[key]).map(key=>[key,event.detail[key]]));
    cartAttempt.properties=Object.keys(properties).length?properties:null;
  });
  for(const name of ['customily-variation-change-started','customily-required-error','customily-add-to-cart-completed'])window.addEventListener(name,clearCartAttempt);
  // Pending image operations can finish after the app starts adding. Those
  // operations must finish before fresh properties are generated, while any
  // changes after generation invalidate the previously generated design.
  for(const name of ['customily-design-changed','customily-options-changed'])window.addEventListener(name,()=>{if(cartAttempt)cartAttempt.properties=null;});
  // Customily's fallback formatter assumes dollars when a theme does not
  // expose its legacy money formatter. Keep its calculated amounts, but
  // render them in the active Shopify currency, including any app surcharges.
  const currency=()=>window.Shopify?.currency?.active||'NOK';
  const money=value=>new Intl.NumberFormat(document.documentElement.lang||'nb-NO',{style:'currency',currency:currency(),maximumFractionDigits:2}).format(value);
  function appCurrency(){
    if(window.customilyShopify)window.customilyShopify.customCurrency=new Intl.NumberFormat(document.documentElement.lang||'nb-NO',{style:'currency',currency:currency()}).formatToParts(0).find(part=>part.type==='currency').value;
  }
  function appAmount(value){
    if(typeof value==='number')return value;
    if(typeof value!=='string')return NaN;
    const number=value.replace(/\s/g,'').replace(',','.');
    return /^\d+(?:\.\d+)?$/.test(number)?Number(number):NaN;
  }
  window.addEventListener('customily-options-loaded',appCurrency);
  window.addEventListener('customily-pricing-change',event=>{
    appCurrency();
    if(!root||state.mode!=='customily')return;
    const price=appAmount(event.detail?.price?.price),compare=appAmount(event.detail?.salePrice?.price);
    if(Number.isFinite(price))for(const el of root.querySelectorAll('.price__regular .price-item--regular,.price__sale .price-item--sale'))write(el,money(price));
    if(Number.isFinite(compare))for(const el of root.querySelectorAll('.price__sale s.price-item--regular'))write(el,money(compare));
  });
  let resolveReady;
  const ready=new Promise(resolve=>resolveReady=resolve);
  const write=(el,value)=>{if(el&&el.textContent!==value)el.textContent=value;};
  const currentForm=()=>{form=root?.querySelector('product-form form');return form;};
  const native=()=>currentForm()?.querySelector('.product-form__submit:not(.customily-personalize-button):not(#customily-cart-btn)');
  const app=()=>root?.querySelector('.customily-personalize-button')||root?.querySelector('#customily-cart-btn')||document.querySelector('#customily-cart-btn');
  const variant=()=>config.variants.find(v=>String(v.id)===String(currentForm()?.querySelector('[name="id"]')?.value||config.selectedId));
  const isConfigured=()=>!variantPending&&!!variant()?.available&&(!state.configuredIds||state.configuredIds.has(String(variant().id)));
  const action=()=>state.mode==='standard'?native():state.mode==='customily'?app():state.mode==='posterly'?ui?.querySelector('button'):null;
  const announce=text=>{const p=ui?.querySelector('[data-pb-personal-status]');if(p){ui.hidden=false;write(p,text);p.hidden=false;}};
  const modal=()=>[...document.querySelectorAll('.customily-modal-container,.customily-modal,dialog[open],cart-drawer.active')].some(e=>e.getClientRects().length&&getComputedStyle(e).visibility!=='hidden');
  function update(){
    if(!root)return;
    if(root.dataset.pbPersonalMode!==state.mode)root.dataset.pbPersonalMode=state.mode;
    const button=ui.querySelector('button'),target=action();
    ui.hidden=state.mode==='standard'||(state.mode==='customily'&&!!app()&&isConfigured());
    button.disabled=state.mode==='loading'||state.mode==='error'||!isConfigured()||(state.mode==='customily'&&!app());
    write(button,state.mode==='loading'?labels.loading:state.mode==='standard'?labels.add:labels.personalize);
    if(state.mode==='error'||(state.appFailed&&!app()))announce(labels.error+(new URLSearchParams(location.search).has('pb_personal_debug')?' [Diagnose: '+(state.errorReason||'customily-button-missing')+
      '; pageButtons='+document.querySelectorAll('.customily-personalize-button').length+
      '; rootButtons='+(root?.querySelectorAll('.customily-personalize-button').length||0)+
      '; cartButton='+!!document.querySelector('#customily-cart-btn')+
      '; sets='+(Array.isArray(window.customily?.product?.sets)?window.customily.product.sets.length:'none')+
      '; appScript='+!!document.querySelector('script[src*="customily"]')+']':''));
    else if(!variantPending&&!variant()?.available)announce(labels.soldOut);
    else if(state.configuredIds&&!isConfigured())announce(labels.variant);
    else if(!ui.hidden)ui.querySelector('[data-pb-personal-status]').hidden=true;
    if(state.mode==='customily'&&app()?.classList.contains('customily-personalize-button')){
      const b=app(),text=[...b.childNodes].find(n=>n.nodeType===Node.TEXT_NODE&&n.textContent.trim());
      // Leave specialised layouts' own button wording intact.
      if(!root.matches('[data-pbp-root]')&&!root.querySelector('[data-pbm-purchase]')){
        if(text){if(text.textContent.trim()!==labels.personalize)text.textContent=labels.personalize;}
        else write(b.querySelector('span'),labels.personalize);
      }
    }
    for(const b of root.querySelectorAll('[data-pbp-launch]')){
      b.disabled=state.mode==='loading'||state.mode==='error'||!isConfigured();
      if(state.mode!=='customily')write(b.querySelector('span')||b,state.mode==='standard'?labels.add:labels.personalize);
    }
    document.body.classList.toggle('pb-personal-modal-open',modal());
  }
  function start(){
    if(state.mode==='loading'){announce(labels.loading);return;}
    if(state.mode==='error'){announce(labels.error);return;}
    if(!isConfigured()){announce(variant()?.available?labels.variant:labels.soldOut);return;}
    if(state.mode==='posterly'){location.assign(config.posterlyUrl);return;}
    const b=action();
    if(!b||b.disabled){announce(state.mode==='customily'?labels.loading:labels.soldOut);return;}
    b.click();
  }
  function isMainForm(target){return root?.contains(target)&&target.matches('form[action*="/cart/add"],product-form form');}
  function stop(event){event.preventDefault();event.stopImmediatePropagation();}
  // Product forms and sticky buttons must not bypass the selected personalizer.
  document.addEventListener('click',event=>{
    const button=event.target.closest('button,a');if(!button||!root)return;
    const launch=button.matches('[data-pb-personal-launch],[data-pbp-launch]');
    const sticky=button.closest('[data-pbm-mobile],[data-pbp-mobile]');
    const nativeClick=button===native();
    const appClick=button===app();
    if(!launch&&!sticky&&!nativeClick&&!appClick)return;
    if(appClick){clearCartAttempt();if(state.mode!=='customily'||!isConfigured()){stop(event);announce(labels.loading);}return;}
    if(nativeClick&&completedCustomization()){
      // Default submit follows this click synchronously. Do not leave a
      // reusable permission if another handler cancels that submit.
      const attempt=cartAttempt;
      setTimeout(()=>{if(cartAttempt===attempt)clearCartAttempt();},0);
      return;
    }
    if(state.mode==='standard'&&!launch)return;
    stop(event);start();
  },true);
  document.addEventListener('submit',event=>{
    if(isMainForm(event.target)&&state.mode!=='standard'){
      if(event.target===currentForm()&&completedCustomization()){clearCartAttempt();return;}
      stop(event);start();
    }
  },true);
  async function load(){
    if(state.mode==='posterly'){resolveReady(state);update();return;}
    const current=++revision;
    try{
      let data=window.customily?.product;
      if(!Array.isArray(data?.sets)||!data.productConfig){
        // Customily app scripts may initialize after DOMContentLoaded. Avoid
        // declaring a product broken until the app has had time to add its config.
        let link=document.querySelector('link[rel="preload"][href*="sh.customily.com/api/settings/unified/"]');
        for(let tries=0;tries<24&&!link;tries++){
          await new Promise(resolve=>setTimeout(resolve,350));
          data=window.customily?.product;
          if(Array.isArray(data?.sets)&&data.productConfig)break;
          link=document.querySelector('link[rel="preload"][href*="sh.customily.com/api/settings/unified/"]');
        }
        if(!Array.isArray(data?.sets)||!data.productConfig){
          if(!link)throw new Error('customily-config-link-missing');
          const response=await fetch(link.href,{credentials:'omit',signal:AbortSignal.timeout(20000)});
          if(!response.ok)throw new Error('customily-config-http-'+response.status);
          data=await response.json();
        }
      }
      if(!Array.isArray(data?.sets)||!data.productConfig)throw new Error('customily-config-invalid');
      if(current!==revision)return;
      state.mode=data.sets.length||data.productConfig.initial_product_id||data.productConfig.assignedSets?.length?'customily':'standard';
      const variants=data.productConfig.conf_variants;
      // Store-managed variants for own-photo posters and Customily mugs can
      // share a base personalization design while retaining the selected
      // Shopify variant ID, price and Customily-generated order properties.
      // Never relax this check for ordinary products or other template types.
      const sharedPersonalization=state.mode==='customily'&&(
        String(config.productId)==='6095886155942'||
        config.templateSuffix==='krus'||
        config.templateSuffix==='personlig-customily'
      );
      state.configuredIds=sharedPersonalization?null:state.mode==='customily'&&Array.isArray(variants)&&variants.length?new Set(variants.map(v=>String(v.id))):null;
    }catch(error){state.mode='error';state.errorReason=String(error?.message||'customily-unknown-error');}
    resolveReady(state);update();document.dispatchEvent(new CustomEvent('pb:personalization-ready',{detail:state}));
    if(state.mode==='customily')appTimer=setTimeout(()=>{if(!app()){state.appFailed=true;update();}},30000);
  }
  function init(){
    root=document.querySelector('[data-pb-personal-root]');if(!root)return;
    ui=root.querySelector('[data-pb-personal-ui]');form=root.querySelector('product-form form');
    if(!ui||!form)return;
    let queued=false;
    observer=new MutationObserver(()=>{if(queued)return;queued=true;requestAnimationFrame(()=>{queued=false;update();});});
    observer.observe(root,{childList:true,subtree:true,attributes:true,attributeFilter:['disabled','value','style','class']});
    root.addEventListener('change',e=>{if(e.target.closest('variant-radios,variant-selects')){clearCartAttempt();variantPending=true;}update();});
    document.addEventListener('afterVariantChanged',()=>{clearCartAttempt();variantPending=false;form=root.querySelector('product-form form');update();});
    for(const name of ['customily-modal-show','customily-after-modal-show','customily-modal-close'])window.addEventListener(name,()=>setTimeout(update,50));
    document.addEventListener('click',()=>setTimeout(update,150));
    update();load();
  }
  window.PBPersonalization={ready,labels,get mode(){return state.mode;},action,start,isConfigured};
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});else init();
  document.addEventListener('shopify:section:load',()=>{observer?.disconnect();clearTimeout(appTimer);init();});
})();

